// import React, { useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import useCurrentStock from '../../../../hooks/useCurrentStock';
import { useRef } from 'react';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiCalendar, FiCreditCard, FiPackage, FiSearch, FiShoppingBag, FiUser, FiX } from 'react-icons/fi';
import beep from '../../../../assets/audio/beep.mp3';
import CustomerList from '../../../../hooks/CustomerList';
import Loader from '../../../Shared/Loader';
import useCurrentStockWithoutSearch from '../../../../hooks/useCurrentStockWithoutSearch';
import useCurrentStockForPosSale from '../../../../hooks/useCurrentStockForPosSale';
import { nextTenantNumber, useTenantNumbering } from '../../../../saas/tenantNumbering';
import '../AddPosSales/AddPosSalesMobile.css';

const AddPosSales = () => {
    const tenantNumbering = useTenantNumbering();
    const { posCustomer } = useSelector((state) => state.salesInvoice);
    const userAc = useSelector((state) => state.user.user);
    const { products, _id, salesInvoice, salesDate, customerCode, salesCustomer,
        salesAddress, salesPhone, salesOpening, fixedDis, roundingDis, totalAmount, grandTotal,
        payment: updatePayment, dueAmount
    } = useSelector((state) => state.salesInvoice.updateSales);
    const [searchText, setSearchText] = useState();

    const handleSearchTermChange = (event) => {
        const value = event?.target?.value || '';
        setSearchTerm(value);
        setIsSearching(Boolean(value.trim()));
    };


    const { isSearching, setIsSearching, searchTerm, setSearchTerm, filtered, isLoading } = useCurrentStockForPosSale(handleSearchTermChange);
    const navigate = useNavigate();
    const location = useLocation();
    const isMobileEdit = location.pathname.startsWith('/mobile/updatepossales/edit/');

    useEffect(() => {
        const exactMatch = filtered.find(product => product.code === searchTerm);
        if (exactMatch) {
            // If an exact match is found, trigger the addProductToInvoice function
            handleAddProductToInvoice(exactMatch);
            setSearchTerm('');
            // setIsSearching(false)
        }
    }, [filtered]);

    const [isPayment, setIsPayment] = useState(false);
    const [isDiscount, setIsDiscount] = useState(false);
    const [discountAmount, setDiscountAmount] = useState('');
    const [payment, setPayment] = useState('');
    const [roundingAmount, setRoundingAmount] = useState(0);
    const [customers, setCustomers] = useState([]);
    const [salesCount, setSalesCount] = useState();
    const [loading, setLoading] = useState(true);
    const invoiceNo = nextTenantNumber(tenantNumbering.Sales_Invoice_Prefix, salesCount?.result, 6);


    const totalRef = useRef('');
    const discountRef = useRef();
    const grandTotalRef = useRef();
    const paymentRef = useRef();
    const dueAmountRef = useRef();
    const discountTypeRef = useRef();

    // const totalRef = useRef('');
    const invoiceRef = useRef('');
    const dateRef = useRef('')
    const beepAudioRef = useRef(null);

    const customerCodeRef = useRef('');
    const customerRef = useRef('');
    const addressRef = useRef('');
    const phoneRef = useRef('');
    const openingRef = useRef('');

    const date = new Date();
    const today = format(date, "yyyy-MM-dd");

    const [productHistory, setProductHistory] = useState([]);


    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getmaincustomers')
            .then(res => res.json())
            .then(data => {
                setCustomers(data);
                setLoading(false)
            })
    }, []);
    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getsalescount')
            .then(res => res.json())
            .then(data => {
                setSalesCount(data);
                console.log(data);
                setLoading(false)
            })
    }, []);

    // useEffect(() => {
    //     if (searchTerm && filtered.length > 0) {
    //         const matchedProduct = filtered.find(product => product.code === searchTerm);
    //         if (matchedProduct) {
    //             handleAddProductToInvoice(matchedProduct);
    //         }
    //     }
    // }, [searchTerm, filtered]);



    // State to store the modified array
    const [dataArray, setDataArray] = useState(products);

    // Function to calculate the default quantity
    const calculateDefaultQuantity = (minimum) => {
        return minimum * 2;
    };

    // Function to calculate the default total
    const calculateDefaultTotal = (defaultQuantity, sell) => {
        return defaultQuantity * sell;
    };

    // Set default values for quantity and total when the component mounts
    useEffect(() => {
        setDataArray(prevDataArray => {
            return prevDataArray.map(item => {
                const defaultQuantity = 1;
                const defaultTotal = calculateDefaultTotal(defaultQuantity, item.sell);
                // const cost = parseFloat(item.purchase) * parseFloat(item.quantity); // Calculate the cost
                return {
                    ...item,
                    // cost: cost.toFixed(2), // Add the cost property
                    quantity: item.quantity || defaultQuantity,
                    total: item.total || defaultTotal,
                };
            });
        });
    }, []);

    // Updated handleInputChange function
    const handleInputChange = (index, field, value) => {
        setDataArray((prevDataArray) => {
            const newDataArray = [...prevDataArray];
            newDataArray[index] = {
                ...newDataArray[index],
                [field]: value,
            };

            newDataArray[index].total =
                newDataArray[index].quantity * newDataArray[index].purchase;

            // Check if quantity exceeds stock
            if (value > newDataArray[index].stock && !newDataArray[index].isExceed) {
                newDataArray[index].isExceed = true; // Set isExceed to true
            } else if (value <= newDataArray[index].stock && newDataArray[index].isExceed) {
                newDataArray[index].isExceed = false; // Set isExceed to false if quantity is within stock
            }

            // Update costHistory dynamically based on the quantity
            const updatedCostHistory = [];

            let remainingQuantity = newDataArray[index].quantity;

            for (const lotEntry of productHistory) {
                const { lot, quantity, rate } = lotEntry;

                if (remainingQuantity > quantity) {
                    // If the remaining quantity is greater than the current lot quantity
                    updatedCostHistory.push({ lot, quantity, rate });
                    remainingQuantity -= quantity;
                } else {
                    // If the remaining quantity is less than or equal to the current lot quantity
                    updatedCostHistory.push({ lot, quantity: remainingQuantity, rate });
                    newDataArray[index].rate = rate; // Update the rate in the main array
                    newDataArray[index].lot = lot;  // Update the lot in the main array
                    break; // Exit the loop as we found the appropriate lot
                }
            }

            newDataArray[index].costHistory = updatedCostHistory;

            // Calculate the average cost based on the updated costHistory
            const totalCost = updatedCostHistory.reduce((totalCost, entry) => {
                return totalCost + entry.quantity * entry.rate;
            }, 0);

            const averageCost = totalCost / newDataArray[index].quantity;

            // Assign the average cost to the purchase property
            newDataArray[index].purchase = averageCost;
            newDataArray[index].total = totalCost;

            return newDataArray;
        });
    };

    // Function to remove an item from the dataArray
    const handleRemoveItem = index => {
        setDataArray(prevDataArray => {
            const newDataArray = [...prevDataArray];
            newDataArray.splice(index, 1);
            return newDataArray;
        });
    };
    const totalValue = dataArray.reduce((total, item) => total + (item.total || 0), 0);
    // Send the modified data to the server (e.g., on form submission)

    // const handleAddProductToInvoice = (product) => {
    //     const url = `https://servers.thakurgaonexpress.com/rupkotha/getpurchaselot?code=${product.code}`;
    //     fetch(url)
    //         .then(res => res.json())
    //         .then(data => {
    //             setProductHistory(data);

    //             // Check if the product already exists in the dataArray
    //             const existingProductIndex = dataArray.findIndex((item) => item._id === product._id);

    //             if (existingProductIndex !== -1) {
    //                 // Raw Material already exists, update the quantity and total
    //                 const updatedDataArray = [...dataArray];
    //                 const defaultQuantity = 1;
    //                 updatedDataArray[existingProductIndex].quantity += 1;
    //                 updatedDataArray[existingProductIndex].total =
    //                     updatedDataArray[existingProductIndex].quantity * updatedDataArray[existingProductIndex].purchase;

    //                 // Update costHistory for the existing product
    //                 const updatedCostHistory = [...data];
    //                 updatedCostHistory.push({
    //                     lot: updatedCostHistory[0]?.lot,
    //                     quantity: 1,
    //                     rate: data[0]?.rate, // Use data[0]?.rate as the new value for rate
    //                 });

    //                 updatedDataArray[existingProductIndex].costHistory = updatedCostHistory;
    //                 setDataArray(updatedDataArray);
    //             } else {
    //                 // Raw Material doesn't exist, add it to the dataArray
    //                 setDataArray((prevDataArray) => {
    //                     const defaultQuantity = 1;
    //                     const defaultTotal = calculateDefaultTotal(defaultQuantity, data[0]?.rate);

    //                     // Create a new costHistory for the new product
    //                     const newCostHistory = [
    //                         {
    //                             lot: data[0]?.lot,
    //                             quantity: 1,
    //                             rate: data[0]?.rate,
    //                         },
    //                     ];

    //                     return [
    //                         ...prevDataArray,
    //                         { ...product, quantity: defaultQuantity, total: defaultTotal, rate: data[0]?.rate, costHistory: newCostHistory },
    //                     ];
    //                 });
    //             }

    //             setIsSearching(false);
    //             setSearchTerm('')

    //             if (beepAudioRef.current) {
    //                 beepAudioRef.current.play();
    //             }
    //         })
    //         .catch(error => {
    //             // Handle fetch error
    //             console.error('Error fetching data:', error);
    //         });
    // };

    // const handleAddProductToInvoice = (product) => {
    //     const url = `https://servers.thakurgaonexpress.com/rupkotha/getpurchaselot?code=${product.code}`;
    //     fetch(url)
    //         .then(res => res.json())
    //         .then(data => {
    //             setProductHistory(data);

    //             // Check if the product already exists in the dataArray
    //             const existingProductIndex = dataArray.findIndex((item) => item._id === product._id);

    //             if (existingProductIndex !== -1) {
    //                 // Raw Material already exists, update the quantity and total
    //                 const updatedDataArray = [...dataArray];
    //                 updatedDataArray[existingProductIndex].quantity += 1;
    //                 updatedDataArray[existingProductIndex].total =
    //                     updatedDataArray[existingProductIndex].quantity * updatedDataArray[existingProductIndex].purchase;

    //                 // Check if the lot already exists in the costHistory array
    //                 const lotIndex = updatedDataArray[existingProductIndex].costHistory.findIndex(entry => entry.lot === data[0]?.lot);
    //                 if (lotIndex !== -1) {
    //                     // If the lot exists, update the quantity
    //                     updatedDataArray[existingProductIndex].costHistory[lotIndex].quantity += 1;
    //                 } else {
    //                     // If the lot doesn't exist, add a new entry
    //                     updatedDataArray[existingProductIndex].costHistory.push({
    //                         lot: data[0]?.lot,
    //                         quantity: 1,
    //                         rate: data[0]?.rate,
    //                     });
    //                 }

    //                 setDataArray(updatedDataArray);
    //             } else {
    //                 // Raw Material doesn't exist, add it to the dataArray
    //                 setDataArray((prevDataArray) => {
    //                     const defaultQuantity = 1;
    //                     const defaultTotal = calculateDefaultTotal(defaultQuantity, data[0]?.rate);

    //                     // Create a new costHistory for the new product
    //                     const newCostHistory = [
    //                         {
    //                             lot: data[0]?.lot,
    //                             quantity: 1,
    //                             rate: data[0]?.rate,
    //                         },
    //                     ];

    //                     return [
    //                         ...prevDataArray,
    //                         { ...product, quantity: defaultQuantity, total: defaultTotal, rate: data[0]?.rate, costHistory: newCostHistory },
    //                     ];
    //                 });
    //             }

    //             setIsSearching(false);
    //             setSearchTerm('')

    //             if (beepAudioRef.current) {
    //                 beepAudioRef.current.play();
    //             }
    //         })
    //         .catch(error => {
    //             // Handle fetch error
    //             console.error('Error fetching data:', error);
    //         });
    // };


    const handleAddProductToInvoice = (product) => {
        const url = `https://servers.thakurgaonexpress.com/rupkotha/getpurchaselot?code=${product.code}`;
        fetch(url)
            .then(res => res.json())
            .then(data => {
                setProductHistory(data);

                // Check if the product already exists in the dataArray
                const existingProductIndex = dataArray.findIndex((item) => item._id === product._id);

                if (existingProductIndex !== -1) {
                    // Raw Material already exists, update the quantity and total
                    const updatedDataArray = [...dataArray];
                    updatedDataArray[existingProductIndex].quantity += 1;
                    updatedDataArray[existingProductIndex].total =
                        updatedDataArray[existingProductIndex].quantity * updatedDataArray[existingProductIndex].purchase;

                    // Update costHistory for the existing product
                    const updatedCostHistory = [];
                    let remainingQuantity = updatedDataArray[existingProductIndex].quantity;

                    for (const lotEntry of data) {
                        const { lot, quantity, rate } = lotEntry;

                        if (remainingQuantity > quantity) {
                            // If the remaining quantity is greater than the current lot quantity
                            updatedCostHistory.push({ lot, quantity, rate });
                            remainingQuantity -= quantity;
                        } else {
                            // If the remaining quantity is less than or equal to the current lot quantity
                            updatedCostHistory.push({ lot, quantity: remainingQuantity, rate });
                            break; // Exit the loop as we found the appropriate lot
                        }
                    }

                    updatedDataArray[existingProductIndex].costHistory = updatedCostHistory;

                    // Check if quantity exceeds stock and update isExceed accordingly
                    if (updatedDataArray[existingProductIndex].quantity > updatedDataArray[existingProductIndex].stock) {
                        updatedDataArray[existingProductIndex].isExceed = true;
                    }

                    setDataArray(updatedDataArray);
                } else {
                    // Raw Material doesn't exist, add it to the dataArray
                    setDataArray((prevDataArray) => {
                        const defaultQuantity = 1;
                        const defaultTotal = calculateDefaultTotal(defaultQuantity, data[0]?.rate);

                        // Create a new costHistory for the new product
                        const newCostHistory = [
                            {
                                lot: data[0]?.lot,
                                quantity: 1,
                                rate: data[0]?.rate,
                            },
                        ];

                        // Check if quantity exceeds stock and set isExceed accordingly
                        const isExceed = defaultQuantity > product.stock;

                        return [
                            ...prevDataArray,
                            { ...product, quantity: defaultQuantity, total: defaultTotal, rate: data[0]?.rate, costHistory: newCostHistory, isExceed },
                        ];
                    });
                }

                setIsSearching(false);
                setSearchTerm('')

                if (beepAudioRef.current) {
                    beepAudioRef.current.play();
                }
            })
            .catch(error => {
                // Handle fetch error
                console.error('Error fetching data:', error);
            });
    };






    // New


    const handleDiscount = (event) => {
        const discount = parseFloat(event?.target?.value);
        const type = discountTypeRef.current.value;

        if (type === '%') {
            setDiscountAmount(total / 100 * discount)
        } else {
            setDiscountAmount(discount);
        }
        setIsDiscount(true);
    }

    const handleRounding = (event) => {
        const amount = parseFloat(event?.target?.value);
        setRoundingAmount(amount);
        setIsDiscount(true);
    }
    const handlePayment = (event) => {
        const payment = parseInt(event?.target?.value);
        setPayment(payment);
        setIsPayment(true);
        setIsDiscount(true);
    }

    const handleSubmitSales = () => {
        const salesInvoice = invoiceRef.current.value;
        const salesDate = dateRef.current.value;
        const customerCode = customerCodeRef.current.innerText;
        const salesCustomer = customerRef.current.innerText;
        const salesAddress = addressRef.current.innerText;
        const salesPhone = phoneRef.current.innerText;
        const salesOpening = parseFloat(openingRef.current.innerText);
        const totalAmount = parseInt(totalRef.current.innerText);
        const discount = discountAmount + roundingAmount;
        const grandTotal = parseInt(grandTotalRef.current.value);
        const paymentdata = parseInt(paymentRef.current.value);
        const payment = paymentdata ? parseInt(paymentRef.current.value) : 0;

        const isAdvance = payment === 0 & grandTotal <= Math.abs(salesOpening) ? true : false;
        const isPaid = payment + Math.abs(salesOpening) >= grandTotal ? true : false;

        const dueData = parseInt(dueAmountRef.current.value)
        const dueAmount = dueData ? parseInt(dueAmountRef.current.value) : 0;

        const user = userAc?.email.split('@')[0];
        let currentDate = new Date(salesDate);
        let monthName = currentDate.toLocaleString('default', { month: 'long' });
        let yearName = currentDate.toLocaleString('default', { year: 'numeric' });
        const month = monthName + " " + yearName;
        const type = 'Pos';
        const paid = dueAmount === 0 ? true : isAdvance === true ? true : isPaid ? true : false;

        const data = {
            products: dataArray, salesInvoice, salesDate, customerCode, salesCustomer, salesAddress,
            salesPhone, salesOpening, totalAmount, discount, fixedDis: discountAmount ? discountAmount : 0,
            roundingDis: roundingAmount ? roundingAmount : 0, grandTotal, payment, user, dueAmount, type, month, paid
        }


        const url = `https://servers.thakurgaonexpress.com/rupkotha/getsales/${_id}`
        fetch(url, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(data),
        })
            .then(res => res.json())
            .then(data => {
                toast.success('Sales Updated Successfull')
                console.log(data);
                navigate(isMobileEdit ? '/mobile/managedefaultsales' : '/managedefaultsales')
                setTimeout(() => { window.location.reload(); }, 2000);

            })

    }



    const total = dataArray.reduce((total, currentValue) => total + parseFloat(currentValue?.total), 0);

    console.log(dataArray);

    if (loading) {
        return <Loader />
    }
    const isAnyExceed = dataArray.some(item => item.isExceed);

    const checkoutGrandTotal = isDiscount === true ? (total - discountAmount - roundingAmount).toFixed(2) : Number(grandTotal ?? total).toFixed(2);
    const checkoutDueAmount = isDiscount === false ? Number(dueAmount ?? total).toFixed(2) : ((total - discountAmount - roundingAmount) - payment).toFixed(2);

    if (isMobileEdit) {
        return <div className="mobile-sale-checkout mobile-sale-checkout--edit">
            <header className="mobile-sale-checkout__hero"><div><p className="mobile-sale-checkout__eyebrow"><FiShoppingBag />Touch POS sale editor</p><h1>Edit POS sale</h1><p>Invoice {salesInvoice || '—'}</p></div><Link className="mobile-sale-checkout__home" to="/mobile/managedefaultsales" aria-label="Back to manage sales"><FiArrowLeft /></Link></header>
            <section className="mobile-sale-checkout__section"><div className="mobile-sale-checkout__section-head"><h2><FiUser />Customer</h2><small>Tap to change</small></div><div className="mobile-sale-checkout__customer-picker"><CustomerList customers={customers} /></div><div className="mobile-sale-checkout__customer-summary"><div className="mobile-sale-checkout__customer-card"><small>Selected customer</small><strong ref={customerRef}>{posCustomer?.name || salesCustomer || 'Walking customer'}</strong><span><span ref={customerCodeRef}>{posCustomer?.code || customerCode || '—'}</span> · <span ref={phoneRef}>{posCustomer?.phone || salesPhone || 'No phone'}</span></span><span ref={addressRef} className="hidden">{posCustomer?.address || salesAddress || 'N/A'}</span></div><div className="mobile-sale-checkout__due-card"><small>Previous due</small><strong ref={openingRef}>{Number(posCustomer?.due ?? salesOpening ?? 0).toFixed(2)}</strong></div></div></section>
            <section className="mobile-sale-checkout__section"><div className="mobile-sale-checkout__section-head"><h2><FiCalendar />Sale details</h2><small>{dataArray.length} item{dataArray.length === 1 ? '' : 's'}</small></div><div className="mobile-sale-checkout__meta-grid"><div className="mobile-sale-checkout__field"><label>Sale date</label><input ref={dateRef} type="date" defaultValue={salesDate} /></div><div className="mobile-sale-checkout__field"><label>Invoice number</label><input ref={invoiceRef} value={salesInvoice || ''} readOnly /></div></div><div className="mobile-sale-checkout__search"><FiSearch /><input onChange={handleSearchTermChange} value={searchTerm || ''} type="text" placeholder="Scan barcode or search product" className="mobile-sale-checkout__search-input" /></div>{isSearching && <div className="mobile-sale-checkout__results">{isLoading ? <div className="mobile-sale-checkout__empty">Searching available products…</div> : filtered?.length ? filtered.map((product) => <button type="button" key={product._id || product.code} className="mobile-sale-checkout__product-result" onClick={() => handleAddProductToInvoice(product)}><div><strong>{product.name}</strong><small>{product.code} · Stock {product.stock}</small></div><span>+</span></button>) : <div className="mobile-sale-checkout__empty">No available product matches this search.</div>}</div>}</section>
            <section className="mobile-sale-checkout__section"><div className="mobile-sale-checkout__section-head"><h2><FiPackage />Cart</h2><small>Total {totalValue.toFixed(2)}</small><span ref={totalRef} className="hidden">{totalValue.toFixed(2)}</span></div><div className="mobile-sale-checkout__cart">{dataArray.length === 0 ? <div className="mobile-sale-checkout__empty">Search a product to add it to this sale.</div> : dataArray.map((product, index) => <article key={product._id || `${product.code}-${index}`} className="mobile-sale-checkout__item"><div className="mobile-sale-checkout__item-top"><div><strong>{product.name}</strong><small>{product.code} · {product.unit || 'Unit'} · Stock {product.stock ?? '—'}</small></div><button type="button" className="mobile-sale-checkout__remove" onClick={() => handleRemoveItem(index)} aria-label={`Remove ${product.name}`}><FiX /></button></div><div className="mobile-sale-checkout__item-controls"><label>Quantity<input type="number" className={product.isExceed ? 'is-exceed' : ''} value={product.quantity || 0} onChange={(event) => handleInputChange(index, 'quantity', parseInt(event.target.value || 0, 10))} /></label><label>Sale rate<input type="number" value={product.sell || 0} onChange={(event) => handleInputChange(index, 'sell', parseFloat(event.target.value || 0))} /></label><strong className="mobile-sale-checkout__line-total">{Number(product.total || 0).toFixed(2)}</strong></div></article>)}</div></section>
            <section className="mobile-sale-checkout__summary"><div className="mobile-sale-checkout__summary-top"><div><small>Grand total</small><strong>{checkoutGrandTotal}</strong><input ref={grandTotalRef} className="hidden" value={checkoutGrandTotal} readOnly /></div><span>{dataArray.length} sale item{dataArray.length === 1 ? '' : 's'}</span></div><div className="mobile-sale-checkout__adjustments"><div className="mobile-sale-checkout__field"><label>Discount type</label><select ref={discountTypeRef} defaultValue="%"><option value="%">Percentage (%)</option><option value="Fixed">Fixed amount</option></select></div><div className="mobile-sale-checkout__field"><label>Discount</label><input ref={discountRef} onChange={handleDiscount} defaultValue={Number(fixedDis || 0).toFixed(2)} type="number" inputMode="decimal" /></div><div className="mobile-sale-checkout__field"><label>Rounding</label><input onChange={handleRounding} defaultValue={Number(roundingDis || 0).toFixed(2)} type="number" inputMode="decimal" /></div><div className="mobile-sale-checkout__field"><label>Current total</label><input value={checkoutGrandTotal} readOnly /></div></div><div className="mobile-sale-checkout__payment-row"><div className="mobile-sale-checkout__pay-card"><small><FiCreditCard />Cash payment</small><input ref={paymentRef} onChange={handlePayment} defaultValue={updatePayment || 0} type="number" inputMode="decimal" /></div><div className="mobile-sale-checkout__pay-card"><small>Due amount</small><input ref={dueAmountRef} value={checkoutDueAmount} readOnly /></div></div><button type="button" onClick={handleSubmitSales} disabled={isAnyExceed || dataArray.length === 0} className="mobile-sale-checkout__submit">Update sale · {checkoutGrandTotal}</button></section>
        </div>;
    }


    return (
        <div className="mx-2 py-4">
            {/* <audio ref={beepAudioRef} src={beep} /> */}
            {/* <audio ref={beepErrorRef} src={error} /> */}
            <h1 className="text-lg font-bold mb-4">POS Sale</h1>
            <div className='flex'>
                <CustomerList customers={customers} />
            </div>
            <div className='flex flex-col lg:flex-row justify-start items-center gap-2'>
                <div className='lg:col-span-4 mt-7'>
                    <table class="table w-full mx-auto">
                        <thead className='text-center'>
                            <tr>
                                <th className='bg-primary text-white normal-case'>Select Date</th>
                                <th className='bg-primary text-white normal-case'>Invoice No</th>
                            </tr>
                        </thead>
                        <tbody className='text-center'>
                            <tr className=''>
                                <td> <input ref={dateRef} type="date" defaultValue={salesDate} placeholder="Date" class="rounded-lg text-center text-xs bg-white p-3 text-textPrimary placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs" required /></td>
                                <td><input ref={invoiceRef} value={salesInvoice} type="text" placeholder="Type Supplier Name Here" class="rounded-lg text-xs text-center bg-white p-3 text-textPrimary placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs" required /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='lg:col-span-7 overflow-x-auto w-full lg:w-auto lg:overflow-visible'>
                    <div className='sm:overflow-x-auto'>
                        <table class="table mx-auto text-xs">
                            <thead className='text-center'>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>Customer Code</th>
                                    <th className='bg-primary text-white normal-case'>Customer Name</th>
                                    <th className='bg-primary text-white normal-case'>Customer Address</th>
                                    <th className='bg-primary text-white normal-case'>Mobile No</th>
                                    <th className='bg-primary text-white normal-case'>Previews Due</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                <tr className=''>
                                    <td ref={customerCodeRef} className='h-8'>{posCustomer?.code ? posCustomer?.code : customerCode}</td>
                                    <td ref={customerRef} className='h-8'>{posCustomer?.name ? posCustomer?.name : salesCustomer}</td>
                                    <td ref={addressRef}>{posCustomer?.address ? posCustomer?.address : salesAddress}</td>
                                    <td ref={phoneRef}>{posCustomer?.phone ? posCustomer?.address : salesPhone}</td>
                                    <td ref={openingRef}>{posCustomer?.due ? (posCustomer?.due)?.toFixed(2) : salesOpening}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className='flex justify-center lg:justify-start items-center my-4'>
                <div class="form-control w-60 mx-auto lg:mx-px">
                    <input onChange={handleSearchTermChange} value={searchTerm} type="text" placeholder="Scan Code/Search Product" class="input text-xs input-bordered border-dark-purple w-full max-w-xs" />
                </div>
            </div>

            <hr />
            <div style={isSearching ? {} : { visibility: 'hidden' }} className={`grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 bg-gray-200 p-2 ${isSearching ? 'h-60' : "h-8"} w-80 overflow-auto`}>
                {
                    filtered?.map(product =>
                        <label for="update-modal" onClick={() => handleAddProductToInvoice(product)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 text-xs p-3 text-white  te  shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{product?.code}-{product?.name}</label>)
                }
            </div>
            <div className='lg:grid lg:grid-cols-12 gap-2 h-screen'>
                <div className='overflow-auto lg:col-span-10 text-xs z-30 mb-4'>
                    <table class="table w-1/2 mx-auto text-xs">
                        <thead className='text-center'>
                            <tr>
                                <th className='bg-primary text-white normal-case'>SL#</th>
                                <th className='bg-primary text-white normal-case'>Product Code</th>
                                <th className='bg-primary text-white normal-case w-20'>Product Name</th>
                                <th className='bg-primary text-white normal-case'>Sale Quantity</th>
                                <th className='bg-primary text-white normal-case'>Unit</th>
                                <th className='bg-primary text-white normal-case'>Sale Rate</th>
                                <th className='bg-primary text-white normal-case'>Total</th>
                                <th className='bg-primary text-white normal-case'>Action</th>
                            </tr>
                        </thead>
                        <tbody className='text-center'>
                            {
                                dataArray?.map((product, index) => <tr key={product._id} className='hover'>
                                    <td className='h-8'>{index + 1}</td>
                                    <td className='h-8'>{product?.code}</td>
                                    <td title={`Available Stock: ${dataArray[index].stock}`} className='text-xs w-20'>{product?.name}</td>
                                    <td><input
                                        type="number"
                                        className={`border border-gray-300 px-2 py-1 rounded-md w-16 text-center ${dataArray[index].isExceed ? 'text-primary' : ''}`}
                                        value={product.quantity || 0}
                                        onChange={e => handleInputChange(index, 'quantity', parseInt(e.target.value))}
                                    /></td>
                                    <td className='h-8 w-8'>{product?.unit}</td>
                                    <td> <input
                                        type="number"
                                        className="border border-gray-300 px-2 py-1 rounded-md w-20 text-center"
                                        value={product.sell || 0}
                                        onChange={e => handleInputChange(index, 'sell', parseFloat(e.target.value))}
                                    /></td>
                                    <td><input type="number" value={(product.total)?.toFixed(2) || 0} placeholder="Type here" className="input text-xs input-bordered text-center h-8 w-28 max-w-lg" readOnly /></td>
                                    <td> <button
                                        className="bg-primary hover:bg-primary text-white font-semibold px-4 py-2 rounded-md"
                                        onClick={() => handleRemoveItem(index)}
                                    >
                                        Remove
                                    </button> </td>
                                </tr>)
                            }

                        </tbody>
                        <tfoot className='text-center h-2'>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className='text-sm font-bold'>Total</td>
                                <td ref={totalRef} className='text-sm font-bold'>{totalValue.toFixed(2)}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Discount</td>
                                <td>
                                    <select ref={discountTypeRef} defaultValue='' class="rounded-lg text-center text-textPrimary text-xs  w-full h-8 max-w-xs" required>
                                        <option selected>%</option>
                                        <option>Fixed</option>
                                    </select>
                                </td>
                                <td> <input ref={discountRef} onChange={handleDiscount} defaultValue={(fixedDis)?.toFixed(2)} type="number" placeholder="Type Discount" className="input input-bordered text-center text-xs w-28 h-8 mx-auto max-w-lg" /></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Rounding</td>
                                <td>
                                </td>
                                <td> <input onChange={handleRounding} defaultValue={(roundingDis)?.toFixed(2)} type="number" placeholder="Type Discount" className="input input-bordered text-center text-xs w-28 h-8 mx-auto max-w-lg" /></td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
               <div className="overflow-auto lg:col-span-2 ml-20 lg:ml-0">
    <div
        style={{ height: "400px" }}
        className="bg-primary w-48 text-xs text-center flex flex-col items-center"
    >
        {/* Grand Total */}
        <div className="w-full mt-4">
            <label className="block text-white normal-case text-sm font-medium mb-2">
                Grand Total
            </label>

            <input
                ref={grandTotalRef}
                type="number"
                value={
                    isDiscount === true
                        ? (
                            total -
                            discountAmount -
                            roundingAmount
                        ).toFixed(2)
                        : grandTotal?.toFixed(2)
                }
                placeholder="Type here"
                className="input text-xs input-bordered text-center w-36 mx-auto max-w-lg"
                readOnly
            />
        </div>

        {/* Cash Payment */}
        <div className="w-full mt-4">
            <label className="block text-white normal-case text-sm font-medium mb-2">
                Cash Payment
            </label>

            <input
                ref={paymentRef}
                onChange={handlePayment}
                defaultValue={updatePayment}
                type="number"
                placeholder="Type Payment"
                className="input text-xs input-bordered text-center w-36 mx-auto max-w-lg"
            />
        </div>

        {/* Due Amount */}
        <div className="w-full mt-4">
            <label className="block text-white normal-case text-sm font-medium mb-2">
                Due Amount
            </label>

            <div className="flex flex-col items-center gap-3">
                <input
                    ref={dueAmountRef}
                    type="number"
                    value={
                        isDiscount === false
                            ? dueAmount?.toFixed(2)
                            : (
                                total -
                                discountAmount -
                                roundingAmount -
                                payment
                            ).toFixed(2)
                    }
                    placeholder="Type here"
                    className="input text-xs input-bordered text-center w-36 max-w-lg"
                    readOnly
                />

                <button
                    onClick={handleSubmitSales}
                    disabled={isAnyExceed}
                    className="btn btn-md text-white"
                >
                    Update Sales
                </button>
            </div>
        </div>
    </div>
</div>
            </div>
        </div>
    );
};

export default AddPosSales;

